var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.125H17.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.125H9.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.625V11.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1253 5.22266L7.87529 5.25078C6.72942 5.25296 5.6208 5.65794 4.74333 6.39487C3.86587 7.1318 3.27543 8.15378 3.07529 9.28203V9.28203L1.53779 17.1664C1.43907 17.717 1.51881 18.2847 1.76538 18.7868C2.01195 19.2889 2.41247 19.6991 2.90852 19.9576C3.40458 20.2161 3.97024 20.3093 4.52303 20.2238C5.07581 20.1383 5.58682 19.8784 5.98154 19.482V19.482L10.0315 15.0008L16.1253 14.9727C17.4182 14.9727 18.6582 14.459 19.5724 13.5448C20.4867 12.6306 21.0003 11.3906 21.0003 10.0977C21.0003 8.80473 20.4867 7.56475 19.5724 6.65051C18.6582 5.73627 17.4182 5.22266 16.1253 5.22266V5.22266Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.925 9.25391L22.4625 17.1664C22.5612 17.717 22.4815 18.2847 22.2349 18.7868C21.9883 19.2889 21.5878 19.6991 21.0918 19.9576C20.5957 20.2161 20.03 20.3093 19.4773 20.2238C18.9245 20.1383 18.4135 19.8784 18.0187 19.482V19.482L13.9688 14.982",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGame);
export default __webpack_public_path__ + "static/media/icon-game.30fc3dd0a402ee41dbd3ac73d61ce412.svg";
export { ForwardRef as ReactComponent };